<template>
  <BaseNew
    @new-confirm-action="createEntry"
    @new-cancel-action="resetForm"
    @new-open-action="loadServerEntry"
    @clear-form-errors="clearFormErrors"
    ref="baseNew"
    width="80%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :modelNameSingular="modelNameSingular"
  >
    <template slot="newForm">
      <Form
        ref="form"
        :entry="entry"
        :extraData="extraData"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseNew>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseNew from "@shared_components/base_new.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      entry: null,
      formErrors: [],
      extraData: null,
    };
  },
  props: {
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseNew: BaseNew
  },
  methods: {
    loadServerEntry: function() {
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_NEW_GROUND_QUERY,
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.entry = response.data.accountContext.ground;
          this.entry.addressAttributes = response.data.accountContext.address;
          this.extraData = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    createServerEntry: function(ground) {
      // console.log("GROUND", ground, this.$refs.form.entryAttributes, this.deepFilterEntryWithAllowedFieldsForMutation(ground, this.$refs.form.entryAttributes));
      // console.log("GROUND", ground, this.entry.validations, this.deepFilterEntryWithAllowedFieldsForMutation(ground, this.entry.validations));
      this.pageLoading = true;
      this.$apollo
        .mutate({
          mutation: CREATE_GROUND_MUTATION,
          variables: {
            input: this.deepFilterEntryWithAllowedFieldsForMutation(ground, this.entry.validations)
          }
        })
        .then(response => {
          var errors = response.data.createGround.errors
          
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseNew.closeDialog();
            this.$emit("entry-created");
            this.resetForm();
          }
        })
        .catch(error => {
          let { graphQLErrors, networkError, response, operation } = error;
          console.log("error", error)
          console.log("caiu no catch");
          console.log(graphQLErrors);
          console.log(networkError);
          console.log(response);
          console.log(operation);
          if (networkError){
            console.log(`[Network error]: ${networkError}`);
          }
          else if (graphQLErrors){
            graphQLErrors.map(({ message, locations, path }) =>
              console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
              )
            );
          }
        })
        .finally(() => (this.pageLoading = false));
    },
    createEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.createServerEntry(this.entry);
        this.resetForm();
      }
    },
    resetForm: function() {
      if (this.$refs.form) {
        this.$refs.form.resetFormInputs();
      }
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};

const LOAD_NEW_GROUND_QUERY = gql `
  {
    accountContext {
      ground {        
        type
        typeName
        name
        area
        price
        enabled
        rentalPrice
        opportunityCost
        addressAttributes {          
          cityId
          postalCode
          street
          neighborhood
          number
          complement
          validations
        }
        validations
      }
      address {        
        postalCode
        street
        neighborhood
        number
        complement
        cityId
        validations
      }
    }
    globalContext {
      allGroundTypes {
        value
        text
      }
      allStates {
        id
        name
        shortName
      }
    }
  }
`;

const CREATE_GROUND_MUTATION = gql `
  mutation($input: GroundCreateInputObject!) {
    createGround(input: $input) {
      ground {
        id
      }
      errors
    }
  }
`;

</script>

<style scoped></style>
